import React, { useEffect, useState } from "react";
import testwrap from 'assets/icons/brain.png'
import { getTestData } from "service/TestService";
import closeicon from 'assets/icons/lock.png'
import openicon from 'assets/icons/unlock.png'
import styles from "./TestBody.module.scss";
import moment from 'moment';
import { useNavigate } from 'react-router-dom'
const TestBody = ({ data, isadmin, log=null }) => {
  const navigate = useNavigate()
 
  const [render, setRender] = useState(false)


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {

    setRender(false)

  }, [render]);

  const handleClick = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/worktest/`, { state: { usedId: id } });
    }
  };
  const handleClickTest = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/useworktest/`, { state: { usedId: id } });
    }
  };

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <div>
      {data?.length === 0 ? (
        <div style={{
          padding: '48px 24px',
          textAlign: 'center',
          background: '#FFFFFF',
          borderRadius: '12px',
          border: '2px solid #F5F5F5'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            background: 'linear-gradient(135deg, #FFE5D9 0%, #FFD5C5 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px'
          }}>📋</div>
          <h3 style={{ color: '#333333', margin: '0 0 12px 0', fontSize: '20px', fontWeight: '700' }}>
            {log === 0 ? 'Нет пройденных тестов' : isadmin ? 'Нет созданных тестов' : 'Нет доступных тестов'}
          </h3>
          <p style={{ color: '#999999', margin: 0, fontSize: '15px' }}>
            {isadmin && log !== 0 ? 'Создайте первый тест, чтобы начать работу' : 'Пока нет тестов в этом разделе'}
          </p>
        </div>
      ) : (
        <div className={styles.test_card_wrapper}>
          <div className={styles.test_table_header}>
            <span>Название</span>
            {log !== 0 && isadmin && <span>Статус</span>}
            {log === 0 && <span>Время</span>}
            <span>{log === 0 ? 'Автор' : 'Дата'}</span>
            <span>Действия</span>
          </div>
      {(log === 0) ? (
        <>  
          {[...data].map((item) => (
            <div key={item.id || item.worktest} className={styles.test_card}>
              <div>
                <p className={styles.title_test}>
                  <img src={testwrap} className={styles.img} alt="Тест" />
                  {item.employee_part_worktest_title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              <div className={styles.date_info}>
                <p className={styles.date_text}>⏱️ {item.time_response}</p>
              </div>
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
              </div>
              <div className={styles.action_buttons}>
                <button 
                  className={styles.open_btn} 
                  onClick={() => handleClickTest(item.worktest)}
                >
                  Просмотреть
                </button>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {[...data].map((item) => (
            <div key={item.id} className={styles.test_card}>
              <div>
                <p className={styles.title_test}>
                  <img src={testwrap} className={styles.img} alt="Тест" />
                  {item.title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              {isadmin && (
                <div>
                  <span className={`${styles.status_badge} ${item.activate ? styles.active : styles.inactive}`}>
                    <img
                      src={item.activate ? openicon : closeicon}
                      className={styles.img_status}
                      alt={item.activate ? "Открыт" : "Закрыт"}
                    />
                    {item.activate ? "Открыт" : "Закрыт"}
                  </span>
                </div>
              )}
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
                <p className={styles.date_text}>{formatDate(item.createdAt)}</p>
              </div>
              <div className={styles.action_buttons}>
                {isadmin ? (
                  <button 
                    className={styles.open_btn} 
                    onClick={() => handleClick(item.id)}
                  >
                    Смотреть
                  </button>
                ) : (
                  <button 
                    className={styles.open_btn} 
                    onClick={() => handleClickTest(item.id)}
                  >
                    Пройти
                  </button>
                )}
              </div>
            </div>
          ))}
        </>
      )}
        </div>
      )}
    </div>
  );
};

export default TestBody;
